
;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.MobileMenu = Marionette.ItemView.extend({
		template: JST.mobileMenu,
		ui: {
			list_menu_item_link: '.sidemenu a',
			all_menu_items: '.submenu ul',
			swipe_body:     'body',
			page_wrapper:   '.main-outer',
			mobile_menu:    '#mobile-menu',
			login_popup:    '.js-login-popup'
		},
		events: {
			'click @ui.list_menu_item_link': 'toggleSubMenuItem',
			'click @ui.login_popup': 'show_login_poup'
		},
		initialize: function(options) {

			this.collection = this.options.menuItems;
			this.subMenuItems = this.options.subMenuItems;
			this.user = APP.module('instance').user;

			this.mobile = this.isMobileAvailable();
			return this.listenEvt().updateModel();

		},
		show_login_poup: function(){
			APP.vent.trigger('show:login:popup', true);
			this.closeMobileMenu();
		},
		bindUIElements: function(){
			_.each(this.ui, function(ui, key){
				this.ui[key] = $(ui);
			}, this);

			return this;
		},
		listenEvt: function(){

			this.listenTo(APP.vent, 'route:change', this.setState);
			this.listenTo(this.user, 'change:session_id', this.render);
			this.listenTo(this.user, 'change', this.render);
			this.listenTo(this.model, 'change', this.render);

			this.listenTo(APP.vent, 'show:menu', this.beforeRenderAction);
			this.listenTo(APP.vent, 'header:re-render', this.render);

			this.listenTo(APP.vent , 'mobile_menu:close', this.closeMobileMenu);

			return this;
		},
		closeMobileMenu: function(){

			if(this.ui.page_wrapper.hasClass('open-menu')){
				this.ui.page_wrapper.removeClass("open-menu")
					.addClass( 'close-menu' )
					.delay(700)
					.queue(function() {
						$(this).removeClass( 'close-menu' );
						$(this).dequeue();
					});
			}

			return this
		},

		beforeRenderAction: function(){
			this.updateModel();
			APP.vent.trigger('mobile_menu:re-render');
			return this;
		},

		updateModel: function() {
			this.model.set({
				items:        this.collection.toJSON(),
				user:         this.user.toJSON(),
				subMenuItems: this.subMenuItems.toJSON(),
				title:        'Site title'
			});

			return this;
		},

		initializeMenu: function(){
			this.updateModel();
		},

		setState: function(state) {

			this.collection.selectActiveState(state);

			return this;
		},
		toggleSubMenuItem: function(e) {

			var
				$this = $(e.currentTarget),
				$sibling = $this.siblings("ul")
			;

			$this.toggleClass('menu-open');

			return !Boolean($sibling.size());
		},
		filterMenuCollection: function(collection){
			return _.where(
				_.map(collection, function(val){
					val.submenu = _.where(val.submenu,{available: true});
					return val;
				}
			), {available: true});
		},
		isMobileAvailable: function(){
			return window.isMobile();
		}

	});


}(window, APP, Backbone, Marionette, $, _));
